/* Consulta NF Produtos: NF-e capturadas da Distribuição de DF-e (backend /nfe-captura) */
import { apiFetch, API_URL, obterToken } from './apiClient';

const B = '/nfe-captura';
const qs = (p) => {
  const u = new URLSearchParams();
  Object.entries(p || {}).forEach(([k, v]) => { if (v !== undefined && v !== null && v !== '') u.set(k, v); });
  const s = u.toString();
  return s ? `?${s}` : '';
};

export const listarClientesNfe = () => apiFetch(`${B}/clientes`);
export const listarNotasNfe = (filtro) => apiFetch(`${B}/notas${qs(filtro)}`);
export const listarExecucoesNfe = (clienteId) => apiFetch(`${B}/execucoes${qs({ cliente_id: clienteId })}`);
export const sincronizarClienteNfe = (id) => apiFetch(`${B}/clientes/${id}/sincronizar`, { method: 'POST' });
export const ativarBuscaNfe = (id, ativo) => apiFetch(`${B}/clientes/${id}/ativacao`, { method: 'PUT', body: JSON.stringify({ ativo }) });
export const executarCapturaNfeTodos = () => apiFetch(`${B}/executar`, { method: 'POST' });
export const manifestarNfe = (id, corpo) => apiFetch(`${B}/clientes/${id}/manifestar`, { method: 'POST', body: JSON.stringify(corpo) });

/* download autenticado (XML ou ZIP do filtro) */
export async function baixarNfe(caminho, nomePadrao) {
  const token = obterToken();
  const r = await fetch(`${API_URL}${B}${caminho}`, { headers: token ? { Authorization: `Bearer ${token}` } : {} });
  if (!r.ok) {
    let msg = 'Erro ao baixar o arquivo';
    try { msg = (await r.json()).error || msg; } catch { /* sem JSON */ }
    throw new Error(msg);
  }
  const nome = (/filename="([^"]+)"/.exec(r.headers.get('content-disposition') || '') || [])[1] || nomePadrao;
  const url = URL.createObjectURL(await r.blob());
  const a = document.createElement('a');
  a.href = url; a.download = nome;
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10000);
}
export const urlZipNfe = (filtro) => `/zip${qs(filtro)}`;
